// Möteskonfiguration
export const MEETING_TEMPLATES = {
  projektgenomgang: {
    type: 'projektgenomgang',
    label: 'Projektgenomgång',
    duration: 90,
    maxPerProject: 1,
    defaultAttendeeRoles: ['customer', 'consultant', 'builder'],
    canBeBookedBy: ['byggkonsult', 'admin'],
    agenda: [
      { title: 'Offert', order: 1, isCustom: false },
      { title: 'Ritningar', order: 2, isCustom: false },
      { title: 'Tidplan', order: 3, isCustom: false },
      { title: 'Materialinköp', order: 4, isCustom: false },
      { title: 'Kommunikation', order: 5, isCustom: false },
      { title: 'Ansvarsfördelning', order: 6, isCustom: false }
    ],
    description: 'Första mötet efter godkänd offert för att gå igenom projektets detaljer.'
  },
  efter_rivning: {
    type: 'efter_rivning',
    label: 'Möte efter rivning',
    duration: 90,
    maxPerProject: 1,
    defaultAttendeeRoles: ['customer', 'consultant', 'architect', 'builder'],
    canBeBookedBy: ['byggkonsult', 'admin'],
    agenda: [],
    description: 'Genomgång efter rivningsfasen för att diskutera eventuella ändringar.'
  },
  byggmote: {
    type: 'byggmote',
    label: 'Byggmöte',
    duration: 60,
    maxPerProject: null, // Obegränsat
    defaultAttendeeRoles: ['customer', 'builder'],
    canBeBookedBy: ['byggkonsult', 'byggare', 'admin'],
    agenda: [],
    description: 'Löpande byggmöten under projektets gång.'
  },
  slutsyn: {
    type: 'slutsyn',
    label: 'Slutsyn',
    duration: 90,
    maxPerProject: 1,
    defaultAttendeeRoles: ['customer', 'consultant', 'builder'],
    optionalAttendeeRoles: ['architect'],
    canBeBookedBy: ['byggkonsult', 'admin'],
    agenda: [
      { title: 'Genomgång', order: 1, isCustom: false },
      { title: 'Anmärkningar', order: 2, isCustom: false },
      { title: 'Godkännande', order: 3, isCustom: false }
    ],
    description: 'Avslutande besiktning när projektet är klart.'
  },
  brief: {
    type: 'brief',
    label: 'Brief',
    duration: 30,
    maxPerProject: 1,
    defaultAttendeeRoles: ['consultant', 'architect'],
    canBeBookedBy: ['byggkonsult', 'admin'],
    agenda: [],
    description: 'Briefmöte mellan byggkonsult och inredningsarkitekt.'
  },
  intromote: {
    type: 'intromote',
    label: 'Intromöte',
    duration: 30,
    maxPerProject: 1,
    defaultAttendeeRoles: ['customer', 'architect'],
    canBeBookedBy: ['inredningsarkitekt', 'admin'],
    agenda: [
      { title: 'Hur funkar inredningsdelen hos Leadme?', order: 1, isCustom: false },
      { title: 'Hur går processen till?', order: 2, isCustom: false },
      { title: 'Vad mer kan vi hjälpa er med när det kommer till design (kulörer, material etc)', order: 3, isCustom: false }
    ],
    description: 'Kort introduktionsmöte via Teams mellan IA och kund.'
  },
  avstamning: {
    type: 'avstamning',
    label: 'Avstämningsmöte',
    duration: 45,
    maxPerProject: null,
    defaultAttendeeRoles: ['customer', 'architect'],
    canBeBookedBy: ['inredningsarkitekt', 'admin'],
    agenda: [],
    description: 'Kort avstämningsmöte via Teams för att gå igenom status på uppdrag.'
  },
  fargkonsultation: {
    type: 'fargkonsultation',
    label: 'Färgsättningskonsultation',
    duration: 60,
    maxPerProject: null,
    defaultAttendeeRoles: ['customer', 'architect'],
    canBeBookedBy: ['inredningsarkitekt', 'admin'],
    defaultLocationType: 'office',
    agenda: [],
    description: 'Färgsättningskonsultation med inredningsarkitekt, vanligtvis på Leadme-kontoret eller via Teams.'
  },
  hemlaxa: {
    type: 'hemlaxa',
    label: 'Hemläxa',
    duration: 45,
    maxPerProject: null,
    defaultAttendeeRoles: ['customer', 'architect'],
    canBeBookedBy: ['inredningsarkitekt', 'admin'],
    agenda: [
      { title: 'Genomgång av hemläxa', order: 1, isCustom: false },
      { title: 'Önskemål och inspiration', order: 2, isCustom: false }
    ],
    description: 'Kort avstämning via Teams för att gå igenom kundens hemläxa.'
  },
  uppfoljning_underlag: {
    type: 'uppfoljning_underlag',
    label: 'Uppföljning på skickat underlag',
    duration: 60,
    maxPerProject: null,
    defaultAttendeeRoles: ['customer', 'architect'],
    canBeBookedBy: ['inredningsarkitekt', 'admin'],
    agenda: [],
    description: 'Uppföljningsmöte via Teams efter att IA har skickat första underlaget till kunden.'
  }
};

// Kontorets adress
export const OFFICE_ADDRESS = 'Bergsgatan 9, 112 23 Stockholm';

// Roll-etiketter
export const ATTENDEE_ROLE_LABELS = {
  customer: 'Kund',
  consultant: 'Byggkonsult',
  architect: 'Inredningsarkitekt',
  builder: 'Byggare',
  subcontractor: 'Underentreprenör',
  external: 'Extern deltagare'
};

// Status-etiketter och färger
export const STATUS_CONFIG = {
  draft: {
    label: 'Utkast',
    color: 'gray',
    bgColor: 'bg-gray-100',
    textColor: 'text-gray-600',
    borderColor: 'border-gray-300'
  },
  proposed: {
    label: 'Väntar på svar',
    color: 'yellow',
    bgColor: 'bg-yellow-100',
    textColor: 'text-yellow-700',
    borderColor: 'border-yellow-300'
  },
  scheduled: {
    label: 'Bokat',
    color: 'green',
    bgColor: 'bg-green-100',
    textColor: 'text-green-700',
    borderColor: 'border-green-300'
  },
  completed: {
    label: 'Genomfört',
    color: 'blue',
    bgColor: 'bg-blue-100',
    textColor: 'text-blue-700',
    borderColor: 'border-blue-300'
  },
  cancelled: {
    label: 'Avbokat',
    color: 'red',
    bgColor: 'bg-red-100',
    textColor: 'text-red-700',
    borderColor: 'border-red-300'
  }
};

// Platstyp-etiketter
// 'teams' blir i backend en plats med adressen "Microsoft Teams"
// (meetingController.getLocation), och bokningen skapar då en Teams-länk
// (arTeamsMote). Valet fanns inte här, så Teams gick bara att boka genom att
// välja "Annan plats" och skriva "Microsoft Teams".
//
// "Annan plats" (custom) är borttaget som val: alla 35 möten som bokats med
// det var Teams-möten (okt 2026). Backend tar fortfarande emot 'custom', så
// gamla möten fungerar som förut.
export const LOCATION_TYPE_LABELS = {
  customer: 'Hos kund',
  office: 'Leadme-kontoret',
  teams: 'Teams'
};

/**
 * Hämta mötestypens label
 */
export function getMeetingTypeLabel(type) {
  return MEETING_TEMPLATES[type]?.label || type;
}

/**
 * Hämta display-namn för ett möte (inkl. nummer för byggmöten)
 */
export function getMeetingDisplayName(meeting) {
  const template = MEETING_TEMPLATES[meeting.type];
  if (!template) return meeting.type;

  if ((meeting.type === 'byggmote' || meeting.type === 'avstamning') && meeting.meetingNumber) {
    const base = `${template.label} #${meeting.meetingNumber}`;
    return meeting.topic ? `${base} - ${meeting.topic}` : base;
  }
  if (meeting.type === 'hemlaxa' && meeting.topic) {
    return `${template.label} - ${meeting.topic}`;
  }
  return template.label;
}

/**
 * Formatera datum och tid för visning
 */
export function formatMeetingDateTime(date, time) {
  if (!date) return '';

  const d = time ? new Date(`${date}T${time}:00`) : new Date(date);
  if (isNaN(d.getTime())) return '';

  const weekdays = ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'];
  const months = ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december'];

  const weekday = weekdays[d.getDay()];
  const day = d.getDate();
  const month = months[d.getMonth()];

  if (time) {
    return `${weekday} ${day} ${month} kl ${time}`;
  }
  return `${weekday} ${day} ${month}`;
}

/**
 * Formatera scheduledAt-datum
 */
export function formatScheduledAt(scheduledAt) {
  if (!scheduledAt) return '';

  const d = new Date(scheduledAt);
  if (isNaN(d.getTime())) return '';

  const weekdays = ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör'];
  const months = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

  const weekday = weekdays[d.getUTCDay()];
  const day = d.getUTCDate();
  const month = months[d.getUTCMonth()];
  const hours = String(d.getUTCHours()).padStart(2, '0');
  const minutes = String(d.getUTCMinutes()).padStart(2, '0');

  return `${weekday} ${day} ${month} kl ${hours}:${minutes}`;
}

/**
 * Formatera datum för input-fält (YYYY-MM-DD)
 */
export function formatDateForInput(date) {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  return d.toISOString().split('T')[0];
}

/**
 * Formatera tid för input-fält (HH:MM)
 */
export function formatTimeForInput(date) {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';
  return `${String(d.getUTCHours()).padStart(2, '0')}:${String(d.getUTCMinutes()).padStart(2, '0')}`;
}

/**
 * Kolla om användaren kan boka en viss mötestyp
 */
export function canBookMeetingType(userRole, meetingType) {
  const template = MEETING_TEMPLATES[meetingType];
  return template?.canBeBookedBy?.includes(userRole) || false;
}

/**
 * Hämta tillgängliga mötestyper för en användare
 */
export function getAvailableMeetingTypes(userRole) {
  return Object.values(MEETING_TEMPLATES).filter(template =>
    template.canBeBookedBy.includes(userRole)
  );
}

/**
 * Hämta roll-etikett
 */
export function getAttendeeRoleLabel(role) {
  return ATTENDEE_ROLE_LABELS[role] || role;
}

/**
 * Beräkna varaktighet i timmar och minuter
 */
export function formatDuration(minutes) {
  if (!minutes) return '';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  if (hours === 0) return `${mins} min`;
  if (mins === 0) return hours === 1 ? '1 timme' : `${hours} timmar`;
  return `${hours} tim ${mins} min`;
}

/**
 * Generera föreslagna tider (nästa 7 arbetsdagar, kl 09, 10, 14, 15)
 */
export function generateSuggestedTimes(count = 3) {
  const suggestions = [];
  const now = new Date();
  let currentDate = new Date(now);
  currentDate.setDate(currentDate.getDate() + 1); // Börja från imorgon

  const timeSlots = ['09:00', '10:00', '14:00', '15:00'];

  while (suggestions.length < count * 3) { // Generera fler än behövs
    // Hoppa över helger
    if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
      const dateStr = currentDate.toISOString().split('T')[0];

      for (const time of timeSlots) {
        suggestions.push({
          date: dateStr,
          time,
          displayText: formatMeetingDateTime(dateStr, time)
        });
      }
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }

  return suggestions.slice(0, count * 4); // Returnera tillräckligt många
}
